import * as yup from "yup"
import { Biblioteca } from "../../types"

export function initialValuesBiblioteca(biblioteca?: Biblioteca | undefined) {
  if (biblioteca) {
    return biblioteca
  }
  return {
    nome: "",
    citta: "",
  }
}

export function validationSchemaBiblioteca() {
  return yup.object().shape({
    nome: yup.string().required("Campo obbligatorio"),
    citta: yup.string().required("Campo obbligatorio"),
  })
}
